import RaceMixins from '../../../../components/_mixins/races'
import DatesMixin from '../../../../components/_mixins/dates'

export default {
  name: 'mini-cart',
  mixins: [RaceMixins, DatesMixin],
  data() {
    return {
    }
  },
  computed: {
    miniCartItems() {
      return this.proposedCartItems
    },
    slottedDate() {
      return this.formatDate(this.selectedDate, 'M/d/y')
    },
    subTotal() {
      return _.reduce(this.miniCartItems, (total, item) => {
        if (this.usePackages && this.isReservationItemType(item)) {
          return total
        }
        return total + (item.quantity * item.rate)
      }, 0)
    },
    taxTotal() {
      return _.reduce(this.miniCartItems, (total, item) => {
        if (this.usePackages && this.isReservationItemType(item)) {
          return total
        }
        return total + (item.quantity * item.tax_amount)
      }, 0)
    },
    netTotal() {
      return this.subTotal + this.taxTotal
    },
  },
  methods:{
    isReservationItemType(item) {
      return item.type === this.reservationType
    },
    getItemSubTotal(item) {
      const quantity = item.quantity * 1
      return quantity * item.rate
    },
    getItemTaxTotal(item) {
      const quantity = item.quantity * 1
      return quantity * item.tax_amount
    },
    getItemTotal(item) {
      return this.getItemSubTotal(item) + this.getItemTaxTotal(item)
    },
  }
}
